<template>
  <TWModal
    :title="$t('envelope.downloadEnvelope')"
    :show="show"
    :loading="false"
    @close="$emit('close')">
    <template v-slot:content>
      <i18n path="envelope.downloadModal.downloadMessage" tag="p">
        <template v-slot:envelopeTitle>
          {{ envelopeTitle }}
        </template>
        <template v-slot:link>
          <a
            @click="downloadEnvelope"
            data-ec="envelope_download_modal"
            data-et="manual_download_link">
            {{ $t('envelope.downloadModal.manualLinkText') }}
          </a>
        </template>
      </i18n>
    </template>

    <template v-slot:controls>
      <BaseButton
        @click.native="$emit('close')"
        data-ec="envelope_download_modal"
        data-et="cta_close_button"
      >
        {{ $t('functional.okThanks') }}
      </BaseButton>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';

export default {
  name: 'EnvelopeDownloadModal',
  components: {
    TWModal,
    BaseButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    envelopeTitle: {
      type: String,
      required: true,
    },
    downloadEnvelope: {
      type: Function,
      required: true,
    },
  },
  watch: {
    show: {
      handler() {
        if (this.show === true) this.downloadEnvelope();
      },
      immediate: true,
    },
  },
};
</script>
